import { Component, input, output } from '@angular/core';
import { WorkAbsence } from '@work-frontend-monorepo/work-rest-api';
import { BadgeComponent, ButtonComponent } from '@work-frontend-monorepo/work-ui/layout';
import { FormatAbsenceDateRangePipe, PrependServerToFileSrcPipe } from '@work-frontend-monorepo/work-ui/pipes';
import { ConfirmActionModalDirective } from '@work-frontend-monorepo/work-ui/modals';

@Component({
  selector: 'sfg-app-absenzen-card',
  templateUrl: './absenzen-card.component.html',
  styleUrls: ['./absenzen-card.component.scss'],
  standalone: true,
  imports: [BadgeComponent, ButtonComponent, FormatAbsenceDateRangePipe, PrependServerToFileSrcPipe, ConfirmActionModalDirective],
})
export class AbsenzenCardComponent {
  absence = input.required<WorkAbsence>();
  canEdit = input(false);
  canDelete = input(false);
  showUserName = input(false);
  showApprovalActions = input(false);

  editClick = output<WorkAbsence>();
  deleteClick = output<WorkAbsence>();
  approveClick = output<WorkAbsence>();
  rejectClick = output<WorkAbsence>();

  protected getStatusVariant(statusName: string | null | undefined): 'success' | 'error' | 'neutral' {
    if (statusName === 'Genehmigt') return 'success';
    if (statusName === 'Abgelehnt') return 'error';
    return 'neutral';
  }

  protected isPartialAbsenceType(typeId: number | null | undefined): boolean {
    return typeId !== null && typeId !== undefined && [6, 7].includes(typeId);
  }
}
